module.exports = __webpack_public_path__ + "img/Tricia.0bc0fa06.jpeg";